/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useEffect, useState } from 'react';
import { Form, Input, Modal, message } from 'antd';
import moment from 'moment';
import { DataService } from '../../../config/dataService/dataService';
import { FORM_HIDE_TIMEOUT_SECONDS } from '../../../config/config';
import { TCenterSelector } from '../../common';

const initialState = {
  title: '',
  training_center_id: null
};

const FormDialog = ({ showDialog, disableOutSideCLose = false, isEdit = false, setReload, editId }) => {
  const [form] = Form.useForm();
  const [busy, setBusy] = useState(false);
  const [centerID, setCenterID] = useState(null);
  const [centerName, setCenterName] = useState(null);

  const fetchData = async (id) => {
    try {
      setBusy(true);
      const response = await DataService.post('/t-courses/get-by-id', { id });
      if (response.data.status) {
        const mData = response.data.data;
        form.setFieldsValue({
          ...mData,
        });
        setCenterName(mData.center_name)
        setCenterID(mData.training_center_id)
      } else {
        message.error(response.data.message || response.message)
      }
      setBusy(false);
    } catch (error) {
      setBusy(false);
      console.error('Error fetching company data:', error);
      message.error(error.message)
    }
  };

  const handleSubmit = async (values) => {
    try {
      setBusy(true);
      const payload = { ...values };

      const endpoint = isEdit ? '/t-courses/update' : '/t-courses/create';
      const response = await DataService.post(endpoint, { ...payload, training_center_id: centerID, id: editId });

      if (response.data.status) {
        message.success(response.data.message, FORM_HIDE_TIMEOUT_SECONDS, () => {
          showDialog(false);
          setReload(true);
        });
      } else {
        setBusy(false);
        message.error(`Error: ${response.data.message}`)
      }
    } catch (error) {
      setBusy(false);
      message.error(`Error submitting data: ${error.message}`)
    }
  };

  useEffect(() => {
    if (isEdit && editId) {
      fetchData(editId);
    }
  }, [isEdit, editId]);

  // console.log('form', form)
  return (
    <Modal
      open
      title={isEdit ? 'Edit Record' : 'Add Record'}
      okText={isEdit ? 'Update' : 'Create'}
      cancelText="Cancel"
      width='50%'
      centered
      confirmLoading={busy}
      onCancel={(event) => {
        const { target, keyCode } = event
        if (['svg', 'span'].includes(String(target.nodeName).toLowerCase())) showDialog(false)
        if (keyCode === 27) showDialog(false)
      }}
      onOk={() => form.submit()}
      cancelButtonProps={{
        disabled: busy
      }}
      destroyOnClose
      closable={false}
    >
      <Form
        layout="horizontal"
        form={form}
        onFinish={handleSubmit}
        disabled={busy}
        labelCol={{ span: 8 }} // Adjust label width
        wrapperCol={{ span: 12 }} // Adjust input width
        initialValues={initialState}
      >
        <Form.Item
          name="training_center_id"
          label="Select Training Center"
          rules={[
            {
              required: true, validator: () => {
                if (!centerID) {
                  return Promise.reject(new Error('Please select a training center !'));
                }
                return Promise.resolve();
              }
            },
          ]}
        >
          <TCenterSelector onItemSelected={setCenterID} defaultValue={centerName} />
        </Form.Item>

        <Form.Item
          name="title"
          label="Name"
          rules={[
            { required: true, message: 'Please input the training course name!' },
          ]}
        >
          <Input placeholder="Enter Training Course Name" />
        </Form.Item>
        <Form.Item
          name="training_cost"
          label="Training Cost"
          rules={[
            {
              required: true, message: 'Please input the training course cost!', validator: (_, value) => {
                if (!value || /^[0-9]+(\.[0-9]+)?$/.test(value)) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Training cost must be a valid number!'));
              },
            },
          ]}
        >
          <Input placeholder="Enter Training Cost" />
        </Form.Item>
        <Form.Item
          name="training_refereshal_cost"
          label="Training Refereshal Cost"
          rules={[
            {
              required: true, message: 'Please input the training course refereshal cost!', validator: (_, value) => {
                if (!value || /^[0-9]+(\.[0-9]+)?$/.test(value)) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Training cost must be a valid number!'));
              },
            },
          ]}
        >
          <Input placeholder="Enter Training Refereshal Cost" />
        </Form.Item>
      </Form>
    </Modal >
  );
};

export default FormDialog;
